import React, { useState, useEffect } from "react";
import baseUrlApi from '../../lib/baseUrlApi';
import { useNavigate } from "react-router-dom";
import { useCookies } from 'react-cookie';
import {ApiRequest} from "../../Consts/ApiRequest";
import {useParams} from "react-router-dom";

type infoInputs = {
    start: string;
    end: string;
    infoDetail: {
        message: string;
        link: string;
        linkMessage: string;
    };
    link: string;
    infoKind: string;
    isComplete: boolean;
    infoDatetime: {
        start: string;
        end: string;
    };
};

const NewsTab = () => {
    const navigate = useNavigate();
    const [infoData, setInfoData] = useState<infoInputs[]>([]);
    const [filterInfoAdminData, setFilterInfoAdminData] = useState<infoInputs[]>([]);
    const [cookies, setCookie, removeCookie] = useCookies(['authority', 'access_token', "siteId", "siteRecno"]);
    const [infoKind, setInfoKind] = useState<string>('0');

    function errorCallback(error:any){
        if (error.response && error.response.status === 401) {
            console.error("Error token error:", error);
            removeCookie('access_token', {path: '/'});
            removeCookie('authority', {path: '/'});
            removeCookie('siteId', {path: '/'});
            removeCookie('siteRecno', {path: '/'});
            navigate("logout");
        }
        console.error("Error fetching dataSite:", error);
    }

    function filterInfo(infoKind: string) {
        setInfoKind(infoKind);
        let result = infoData.filter(item => {
            console.log(infoKind);
            if (infoKind === "") {
                return true; // すべてのデータを表示
            }
            return item.infoKind == infoKind;
        });
        setFilterInfoAdminData(result);
    }

    useEffect(() => {
        let params = {
            "prcKind": 0,
        }
        const token = cookies.access_token ?? "";
        ApiRequest.getLoginInfo(
            params,
            token,
            (response:any) => {
                if (response.data.infos) {
                    setInfoData(response.data.infos);
                }
            }, (error:any) => {
                errorCallback(error);
            });
    }, []);

    useEffect(() => {
        // infoDataが変更された際にお知らせ情報をフィルタリングする
        filterInfo("0");
    }, [infoData]);


    return (
        <section className="information-block">
            <div className="information-head-block">
                <ul className="page-tabs">
                    <li className={infoKind == "0" ? "active" : ""}>
                        <a onClick={() => filterInfo("0")}>お知らせ</a>
                    </li>
                    <li className={infoKind == "1" ? "active" : ""}>
                        <a onClick={() => filterInfo("1")}>障害情報</a>
                    </li>
                </ul>
            </div>
            {filterInfoAdminData.map((item, index) => (
                <div className="information-body-block" key={index}>
                    <div className="inforamation-box">
                        <div className="inforamation-item">
                            <div className="information-date">
                                {item.infoDatetime.start}
                            </div>
                            <div className="information-text">
                                <div dangerouslySetInnerHTML={{ __html: item.infoDetail.message.replace(/(?:\r\n|\r|\n)/g, '<br>') }} />
                                <p>
                                    {(item.infoDetail.message && item.infoDetail.linkMessage)?
                                    <a href={item.infoDetail.link} target={"_blank"}>
                                        <div dangerouslySetInnerHTML={{ __html: item.infoDetail.linkMessage.replace(/(?:\r\n|\r|\n)/g, '<br>') }} />
                                    </a> : <></>
                                    }
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </section>
    )
};

export default NewsTab;
